import { Component, OnInit } from '@angular/core';

export interface TournamentDetail {
  no: number;
  date: string;
  year: string;
  venue: string;
  level: string;
  achievement: string;
  schoolCollege?: string;
  remarks?: string;
}

export interface PlayerDetails {
  totalTournaments: number;
  gold: number;
  silver: number;
  bronze: number;
  participation: number;
  award?: string;
  tournaments: TournamentDetail[];
}

export interface Player {
  name: string;
  sport: string;
  image: string;
  country?: string;
  details?: PlayerDetails;
}

@Component({
  selector: 'app-international-players',
  templateUrl: './international-players.component.html',
  styleUrls: ['./international-players.component.scss']
})
export class InternationalPlayersComponent implements OnInit {

  selectedPlayer: Player | null = null;

  players: Player[] = [
    {
      name: 'Anchal',
      sport: 'Skating',
      image: '/assets/int player file 1/Anchal ,international,skating (2).jpeg',
      country: 'India',
      details: {
        totalTournaments: 3,
        gold: 1,
        silver: 0,
        bronze: 0,
        participation: 2,
        tournaments: [
          { no: 1, date: '25oct- 1 Nov.2014', year: '2014', venue: 'Tourcoing, France', level: '12th Ladies World Roller Hockey Championship', achievement: 'Participation', schoolCollege: 'college' },
          { no: 2, date: '24 Sept to 1 Oct 2016', year: '2016', venue: 'Chile', level: '13th Ladies World Chmapionship', achievement: 'Participation', schoolCollege: 'college' },
          { no: 3, date: '4 to 14 Sept 2018', year: '2018', venue: 'South Korea', level: '18th Asian Roller Skating Championship', achievement: 'Gold', schoolCollege: 'college' }
        ]
      }
    },
    {
      name: 'Anika',
      sport: 'Skating',
      image: '/assets/int player file 1/Anika  international player ,Skating.jpg',
      country: 'India',
      details: {
        totalTournaments: 2,
        gold: 1,
        silver: 0,
        bronze: 0,
        participation: 1,
        tournaments: [
          { no: 1, date: '9 to 14 Jan.2010', year: '2010', venue: 'Dalian,China', level: '13th Asian Championship', achievement: 'Gold' },
          { no: 2, date: '25 to 2 Jan.2010', year: '2010', venue: 'Alcobandas,Madrid', level: '10th World Cup', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Anupal',
      sport: 'Judo',
      image: '/assets/int player file 1/Anupal,international  player ,Judo.jpg',
      country: 'India',
      details: {
        totalTournaments: 1,
        gold: 0,
        silver: 0,
        bronze: 0,
        participation: 1,
        tournaments: [
          { no: 1, date: '2010-11', year: '2010-11', venue: 'Delhi', level: 'Kurash World Champ.', achievement: 'Participation', schoolCollege: 'College' }
        ]
      }
    },
    {
      name: 'Asmi',
      sport: 'Skating',
      image: '/assets/int player file 1/Asmi, International Player, SKATING.jpeg',
      country: 'India',
      details: {
        totalTournaments: 3,
        gold: 1,
        silver: 0,
        bronze: 0,
        participation: 2,
        tournaments: [
          { no: 1, date: '4 to 14 Sept 2018', year: '2018', venue: 'South Korea', level: '18th Asian Roller Skating Championship', achievement: 'Gold' },
          { no: 2, date: '4 to 14 July 2019', year: '2019', venue: 'Spain', level: 'World Roller Games', achievement: 'Participation' },
          { no: 3, date: '18-28/10/.2023', year: '2024', venue: 'China', level: '19th Asian Rollar and inline hockey Champ.', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Gagandeep',
      sport: 'Skating',
      image: '/assets/int player file 1/Gagandeep ,International Player, Skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 7,
        gold: 1,
        silver: 0,
        bronze: 1,
        participation: 5,
        tournaments: [
          { no: 1, date: '30 to 5 July 2014', year: '2014', venue: 'France', level: 'Inline Hockey World Cup', achievement: 'Participation' },
          { no: 2, date: '20 to 24 Sept. 2014', year: '2014', venue: 'Haning (China)', level: '16th Asian Inline Hockey Championship', achievement: 'Bronze' },
          { no: 3, date: '7 to 13 June 2015', year: '2015', venue: 'Arjantina', level: 'Worls Inline Hockey Championship', achievement: 'Participation' },
          { no: 4, date: '11 to 25 June 2016', year: '2016', venue: 'Italy', level: 'World Inline Hockey Chmapionship', achievement: 'Participation' },
          { no: 5, date: '12 to 16 Oct 2016', year: '2016', venue: 'China', level: '16th Asian Inline Hockey Championship', achievement: 'Participation' },
          { no: 6, date: '25 Aug to 8 Sept 2017', year: '2017', venue: 'China', level: 'World Roller Games', achievement: 'Participation' },
          { no: 7, date: '4 to 14 Sept 2018', year: '2018', venue: 'South Korea', level: '18th Asian Roller Skating Championship', achievement: 'Gold' }
        ]
      }
    },
    {
      name: 'Gurjot',
      sport: 'Skating',
      image: '/assets/int player file 1/Gurjot,international,skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 1,
        gold: 0,
        silver: 0,
        bronze: 0,
        participation: 1,
        tournaments: [
          { no: 1, date: '25 Aug to 8 Sept 2017', year: '2017', venue: 'China', level: 'World Roller Games', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Gurmail',
      sport: 'Handball',
      image: '/assets/bheem awardes/Gurmail,  BHIM Award ,International player  Hand ball.jpeg',
      country: 'India',
      details: {
        totalTournaments: 2,
        gold: 0,
        silver: 0,
        bronze: 0,
        participation: 2,
        award: 'BHIM AWARD',
        tournaments: [
          { no: 1, date: '-', year: '2008-09', venue: 'Bangkok', level: '12th Assian Women .', achievement: 'Participation' },
          { no: 2, date: '19-29 Nov.2010', year: '2009-10', venue: 'China', level: 'Asian Handball', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Gurpreet',
      sport: 'Athletic (Javlin Throw)',
      image: '/assets/int player file 1/Gurpreet, International Player  javlin.jpeg',
      country: 'India',
      details: {
        totalTournaments: 8,
        gold: 1,
        silver: 0,
        bronze: 2,
        participation: 5,
        tournaments: [
          { no: 1, date: '23-Jun-07', year: '2007-08', venue: 'Guwahati', level: 'Asian Grand Fix Champ.', achievement: 'Participation' },
          { no: 2, date: '27-06-2007', year: '2007-08', venue: 'Pune', level: 'Asian Grand Fix Champ.', achievement: 'Participation' },
          { no: 3, date: '-', year: '2006-07', venue: 'Colombo (Shir Lanka)', level: 'SAF (South Asian Games)', achievement: 'Participation' },
          { no: 4, date: '8-9-03-2008', year: '2008', venue: 'Kochi', level: 'South Asian Championship', achievement: 'Bronze' },
          { no: 5, date: '-', year: '2006-07', venue: 'Guwahati', level: 'Asian Grand Prix IInd leg', achievement: 'Participation' },
          { no: 6, date: '-', year: '2006-07', venue: 'New Delhi', level: 'Salwan International', achievement: 'Bronze' },
          { no: 7, date: '-', year: '2006-07', venue: '-', level: 'Asian Grand Prix 3rd leg', achievement: 'Participation' },
          { no: 8, date: '8-10-04-2016', year: '2016', venue: 'Nepal', level: 'South Asian Championship', achievement: 'Gold' }
        ]
      }
    },
    {
      name: 'Gurpreet',
      sport: 'Skating',
      image: '/assets/int player file 2/Gurpreet ,International Player,Skating.jpg',
      country: 'India',
      details: {
        totalTournaments: 5,
        gold: 2,
        silver: 1,
        bronze: 0,
        participation: 2,
        tournaments: [
          { no: 1, date: '28 to 2 Dec.2007', year: '2007', venue: 'Kolkata', level: '12th Asian Championship', achievement: 'Gold' },
          { no: 2, date: '9 to 14 Jan.2010', year: '2010', venue: 'Dalian,China', level: '13th Asian Championship', achievement: 'Gold' },
          { no: 3, date: '25 to 2 Jan.2010', year: '2010', venue: 'Alcobandas, Madrid', level: '10th World Cup', achievement: 'Participation' },
          { no: 4, date: '-', year: '2008', venue: 'japan', level: '09th World Cup', achievement: 'Participation' },
          { no: 5, date: '9 to 14 July 2010', year: '2010', venue: 'Taiwan.Kaohsing', level: '14th Asian Championship', achievement: 'Silver' }
        ]
      }
    },
    {
      name: 'Harpreet',
      sport: 'Skating',
      image: '/assets/bheem awardes/Harpreet , Bhim AWARD ,International  Player ,Skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 5,
        gold: 1,
        silver: 1,
        bronze: 0,
        participation: 3,
        tournaments: [
          { no: 1, date: '10 to 17 Nov.2012', year: '2012', venue: 'Brazil', level: '11th World Cup', achievement: 'Participation' },
          { no: 2, date: '28 to 2 Oct. 2012', year: '2012', venue: 'China', level: '15th Asian Championship', achievement: 'Gold' },
          { no: 3, date: '14 to 20 July2013', year: '2013', venue: 'California ( U.S.A.)', level: 'Inline Hockey World Cup', achievement: 'Participation' },
          { no: 4, date: '30 to 5 July 2014', year: '2014', venue: 'France', level: 'Inline Hockey World Cup', achievement: 'Participation' },
          { no: 5, date: '20 to 24 Sept. 2014', year: '2014', venue: 'Haning (China)', level: '16th Asian Inline Hockey Championship', achievement: 'Bronze' }
        ]
      }
    },
    {
      name: 'Jashandeep',
      sport: 'Skating',
      image: '/assets/int player file 1/Jashandeep, International Player ,Skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 5,
        gold: 0,
        silver: 0,
        bronze: 1,
        participation: 4,
        tournaments: [
          { no: 1, date: '30 to 5 July 2014', year: '2014', venue: 'France', level: 'Inline Hockey World Cup', achievement: 'Participation' },
          { no: 2, date: '20 to 24 Sept. 2014', year: '2014', venue: 'Haning (China)', level: '16th Asian Inline Hockey Championship', achievement: 'Bronze' },
          { no: 3, date: '11 to 25 June 2016', year: '2016', venue: 'Italy', level: 'World Inline Hockey Chmapionship', achievement: 'Participation' },
          { no: 4, date: '12 to 16 Oct 2016', year: '2016', venue: 'China', level: '16th Asian Inline Hockey Championship', achievement: 'Participation' },
          { no: 5, date: '25 Aug to 8 Sept 2017', year: '2017', venue: 'China', level: 'World Roller Games', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Jyoti',
      sport: 'Judo',
      image: '/assets/int player file 1/jyoti,international player,judo.jpeg',
      country: 'India',
      details: {
        totalTournaments: 4,
        gold: 1,
        silver: 0,
        bronze: 0,
        participation: 3,
        tournaments: [
          { no: 1, date: '11 to 18 July 2016', year: '2016', venue: 'Trabzon Turkey', level: 'ISF World School', achievement: 'Participation' },
          { no: 2, date: '12-15 Oct., 2015-16', year: '2016', venue: 'Bankok', level: 'Asian Youth & Junior', achievement: 'Participation' },
          { no: 3, date: '13 to 16 July 2017', year: '2017', venue: 'Bishkek', level: '11th Asian Cadet & Junior Judo Championship', achievement: 'Participation' },
          { no: 4, date: '4 to 11 Nov 2018-19', year: '2018', venue: 'Jaipur (Rajasthan)', level: 'Commenwealth Judo Championship', achievement: 'Ist' }
        ]
      }
    },
    {
      name: 'Kajal',
      sport: 'Skating',
      image: '/assets/int player file 1/Kajal, International player, Skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 7,
        gold: 0,
        silver: 0,
        bronze: 1,
        participation: 6,
        tournaments: [
          { no: 1, date: '23 to 27 Oct 2012', year: '2012', venue: 'China', level: '15th Asian InlineChampionship', achievement: 'Participation' },
          { no: 2, date: '14 to 20 July2013', year: '2013', venue: 'California( U.S.A.)', level: 'Inline Hockey World Cup', achievement: 'Participation' },
          { no: 3, date: '30 to 5 July 2014', year: '2014', venue: 'France', level: 'Inline Hockey World Cup', achievement: 'Participation' },
          { no: 4, date: '20 to 24 Sept. 2014', year: '2014', venue: 'Haning (China)', level: '16th Asian Inline Hockey Championship', achievement: 'Bronze' },
          { no: 5, date: '11 to 25 June 2016', year: '2016', venue: 'Italy', level: 'World Inline Hockey Chmapionship', achievement: 'Participation' },
          { no: 6, date: '12 to 16 Oct 2016', year: '2016', venue: 'China', level: '16th Asian Inline Hockey Championship', achievement: 'Participation' },
          { no: 7, date: '25 Aug to 8 Sept 2017', year: '2017', venue: 'China', level: 'World Roller Games', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Karamdeep',
      sport: 'Yoga',
      image: '/assets/int player file 1/karamdeep,international Player ,yoga.jpeg',
      country: 'India',
      details: {
        totalTournaments: 11,
        gold: 14,
        silver: 17,
        bronze: 4,
        participation: 0,
        tournaments: [
          { no: 1, date: '18 to 20 Sep.2009', year: '2009', venue: 'Italy (Rome)', level: '18th World Cup (Athletic Ridnic Solo)', achievement: '2 Silver 1 Bronze' },
          { no: 2, date: '26 to 27Sept 2010', year: '2010', venue: 'Arezentina', level: '19th World Championship', achievement: '1Gold 2 Silver 1Bronze' },
          { no: 3, date: '23 to 25 Nov. 2012', year: '2012', venue: 'Moscow(Russia)', level: '21st World Yoga Championship', achievement: '3Gold 1 Silver' },
          { no: 4, date: '31 to 2 Sep.2012', year: '2012', venue: 'Hyderabad', level: '2nd Asian Championship', achievement: '2 silver 1Bronze' },
          { no: 5, date: '13 to 14 Oct.2013', year: '2013', venue: 'Paris', level: '22th World Cup', achievement: '4Gold 2Silver' },
          { no: 6, date: '29 to 2 Oct.2013', year: '2013', venue: 'Malaysia', level: '3rd Asian Championship', achievement: '2 Silver' },
          { no: 7, date: '14 to 16 Sept 2014', year: '2014', venue: 'Korea', level: '4th Asian Yoga Championship', achievement: '1 Gold 1 Silver' },
          { no: 8, date: '19 to 21 June 2015', year: '2015', venue: 'Bangkok', level: '5th Asian Yoga Championship', achievement: '1 Gold 1 Silver 1 Bronze' },
          { no: 9, date: '18 to 20 Dec 2015', year: '2015', venue: 'Malaysia', level: '24th World Championship', achievement: '2 Gold 1 Silver' },
          { no: 10, date: '3 to 5 Sept 2016', year: '2016', venue: 'Vietnum', level: '6th Asian Yoga Championship', achievement: '2 Gold 1 Silver' },
          { no: 11, date: '24 to 26 March 2017', year: '2017', venue: 'Kerala', level: '1st Federation Yoga Sports cup', achievement: '2 Silver' }
        ]
      }
    },
    {
      name: 'Karamjeet',
      sport: 'Skating',
      image: '/assets/int player file 1/karamjeet,international,skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 1,
        gold: 1,
        silver: 0,
        bronze: 0,
        participation: 0,
        tournaments: [
          { no: 1, date: '9 to 14 Jan.2010', year: '2010', venue: 'Dalian,China', level: '13th Asian Championship', achievement: 'Gold' }
        ]
      }
    },
    // OTHER INTERNATIONAL PLAYERS
    { name: 'Hemlata', sport: 'Skating', image: '/assets/int player file 1/Hemlata, International Player ,Skating.jpeg' },
    {
      name: 'Manju (6098)',
      sport: 'Throwball',
      image: '/assets/int player file 1/Manju,International Player,Throw ball.jpg',
      country: 'India',
      details: {
        totalTournaments: 1,
        gold: 1,
        silver: 0,
        bronze: 0,
        participation: 0,
        tournaments: [
          { no: 1, date: '09 to 11 Nov 2017', year: '2017', venue: 'Shri Lanka (Kegulu Vidyalaya Indoor Stadium)', level: 'Indian Women Throwball Asian Championship', achievement: 'Gold' }
        ]
      }
    },
    {
      name: 'Meera',
      sport: 'Skating',
      image: '/assets/int player file 1/Meera  international player, Skating.jpg',
      country: 'India',
      details: {
        totalTournaments: 6,
        gold: 2,
        silver: 1,
        bronze: 0,
        participation: 3,
        tournaments: [
          { no: 1, date: '30 to 8 Oct.2006', year: '2006', venue: 'Chilie', level: '8th World Cup', achievement: 'Participation', schoolCollege: 'School' },
          { no: 2, date: '28 to 2 Dec.2007', year: '2007', venue: 'Kolkata', level: '12th Asian Championship', achievement: 'Gold', schoolCollege: 'School' },
          { no: 3, date: '5 to 11 Oct.2008', year: '2008', venue: 'Japan', level: '9th World Cup', achievement: 'Participation', schoolCollege: 'College' },
          { no: 4, date: '9 to 14 Jan.2010', year: '2010', venue: 'Dalian,China', level: '13th Asian Championship', achievement: 'Gold', schoolCollege: 'College' },
          { no: 5, date: '25 to 2 Jan.2010', year: '2010', venue: 'Alcobandas,Madrid', level: '10th World Cup', achievement: 'Participation', schoolCollege: 'College' },
          { no: 6, date: '9 to 14 July 2010', year: '2010', venue: 'Taiwan.Kaohsing', level: '14th Asian Championship', achievement: 'Silver', schoolCollege: 'College' }
        ]
      }
    },
    {
      name: 'Milanpreet',
      sport: 'Skating',
      image: '/assets/bheem awardes/Milanpreet kaur, BhimAward, International player, Skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 8,
        gold: 4,
        silver: 1,
        bronze: 0,
        participation: 3,
        award: 'BHIM AWARD',
        tournaments: [
          { no: 1, date: '30 to 8 Oct.2006', year: '2006', venue: 'Chilie', level: '8th World Cup', achievement: 'Participation' },
          { no: 2, date: '28 to 2 Dec.2007', year: '2007', venue: 'Kolkata', level: '12th Asian Championship', achievement: 'Gold' },
          { no: 3, date: '9 to 14 Jan.2010', year: '2010', venue: 'Dalian,China', level: '13th Asian Championship', achievement: 'Gold' },
          { no: 4, date: '25 to 2 Jan.2010', year: '2010', venue: 'Alcobandas, Madrid', level: '10th World Cup', achievement: 'Participation' },
          { no: 5, date: '9 to 14 July 2010', year: '2010', venue: 'Taiwan.Kaohsing', level: '14th Asian Championship', achievement: 'Silver' },
          { no: 6, date: '10 to 17 Nov.2012', year: '2012', venue: 'Brazil', level: '11th World Cup', achievement: 'Participation' },
          { no: 7, date: '28 to 2 Oct. 2012', year: '2012', venue: 'China', level: '15th Asian Championship', achievement: 'Gold' },
          { no: 8, date: '24 to 28 sept.2014', year: '2014', venue: 'China', level: '16th Asian Rollar Hockey Championship', achievement: 'Gold' }
        ]
      }
    },
    {
      name: 'Mithlesh',
      sport: 'Judo',
      image: '/assets/int player file 1/Mitlesh,International,Judo.jpeg',
      country: 'India',
      details: {
        totalTournaments: 3,
        gold: 0,
        silver: 0,
        bronze: 0,
        participation: 3,
        tournaments: [
          { no: 1, date: '9 to 14 Dec.2013', year: '2013', venue: 'China', level: 'Youth & Junior Asian Judo Champion.', achievement: 'Participation' },
          { no: 2, date: '7 to 11 Sept 2016', year: '2016', venue: 'Kochi (Kerla)', level: '10 th Asian Cadet & Junior Judo Championship', achievement: '4th Participation' },
          { no: 3, date: '13 to 20 Aug.2016', year: '2016', venue: 'China,Nanzing', level: '2 nd Youth Asian Games', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Monika',
      sport: 'Handball',
      image: '/assets/int player file 1/Monika ,international player,handball.jpeg',
      country: 'India',
      details: {
        totalTournaments: 2,
        gold: 0,
        silver: 0,
        bronze: 0,
        participation: 2,
        tournaments: [
          { no: 1, date: '12 to 18 Dec.2012', year: '2012', venue: 'Nepal', level: 'I.H.F. South Asian Challenge Trophy Ch.', achievement: 'Participation' },
          { no: 2, date: '13 to 18 July 2013', year: '2013', venue: 'Uzebekistan', level: 'I.H.F.  Challenge Trophy Central Asia', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Muskan',
      sport: 'Skating',
      image: '/assets/int player file 1/muskan,international,skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 5,
        gold: 0,
        silver: 0,
        bronze: 1,
        participation: 4,
        tournaments: [
          { no: 1, date: '24 to 28 sept.2014', year: '2014', venue: 'China', level: '16th Asian Rollar Hockey Championship', achievement: 'Bronze' },
          { no: 2, date: '30th June -5 July.2014', year: '2014', venue: 'France', level: 'World Inline Hockey Chmapionship', achievement: 'Participation' },
          { no: 3, date: '11 to 25 June 2016', year: '2016', venue: 'Italy', level: 'World Inline Hockey Chmapionship', achievement: 'Participation' },
          { no: 4, date: '12 to 16 Oct 2016', year: '2016', venue: 'China', level: '16th Asian Inline Hockey Championship', achievement: 'Participation' },
          { no: 5, date: '25 Aug to 8 Sept 2017', year: '2017', venue: 'China', level: 'World Roller Games', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Pooja Malik',
      sport: 'Skating',
      image: '/assets/int player file 1/pooja  international player  Skating.jpg',
      country: 'India',
      details: {
        totalTournaments: 4,
        gold: 2,
        silver: 1,
        bronze: 0,
        participation: 1,
        tournaments: [
          { no: 1, date: '30 to 8 Oct.2006', year: '2006', venue: 'Chilie', level: '8th World Cup', achievement: 'Participation' },
          { no: 2, date: '28 to 2 Dec.2007', year: '2007', venue: 'Kolkata', level: '12th Asian Championship', achievement: 'Gold' },
          { no: 3, date: '9 to 14 Jan.2010', year: '2010', venue: 'Dalian,China', level: '13th Asian Championship', achievement: 'Gold' },
          { no: 4, date: '9 to 14 July 2010', year: '2010', venue: 'Taiwan.Kaohsing', level: '14th Asian Championship', achievement: 'Silver' }
        ]
      }
    },
    {
      name: 'Preeti (6110)',
      sport: 'Judo',
      image: '/assets/int player file 1/preeti,international Player,judo.jpeg',
      country: 'India',
      details: {
        totalTournaments: 1,
        gold: 0,
        silver: 0,
        bronze: 0,
        participation: 1,
        tournaments: [
          { no: 1, date: '25 to 27 August 2017', year: '2017', venue: 'China (Taipai)', level: 'World University Championship', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Sabdeep (2117)',
      sport: 'Skating',
      image: '/assets/int player file 1/sabdeep,international,skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 11,
        gold: 5,
        silver: 1,
        bronze: 0,
        participation: 5,
        tournaments: [
          { no: 1, date: '28 to 2 Dec.2007', year: '2007', venue: 'Kolkata', level: '12th Asian Championship', achievement: 'Gold' },
          { no: 2, date: '5 to 11 Oct.2008', year: '2008', venue: 'Japan', level: '9th World Cup', achievement: 'Participation' },
          { no: 3, date: '9 to 14 Jan.2010', year: '2010', venue: 'Dalian,China', level: '13th Asian Championship', achievement: 'Gold' },
          { no: 4, date: '10 to 14 July2010', year: '2010', venue: 'Taiwan.Kaohsing', level: '14th Asian Championship', achievement: 'Silver' },
          { no: 5, date: '10 to 17 Nov.2012', year: '2012', venue: 'Brazil', level: '11th World Cup', achievement: 'Participation' },
          { no: 6, date: '15 to 19 Sept 2010', year: '2010', venue: 'Alcobandas, Madrid', level: '10th World Cup', achievement: 'Participation' },
          { no: 7, date: '28 to 2 Oct. 2012', year: '2012', venue: 'China', level: '15th Asian Championship', achievement: 'Gold' },
          { no: 8, date: '28 Oct to 4 Nov 2014', year: '2014', venue: 'France', level: '12th World Championship', achievement: 'Participation' },
          { no: 9, date: '24 to 28 sept.2014', year: '2014', venue: 'China', level: '16th Asian Rollar Hockey Championship', achievement: 'Gold' },
          { no: 10, date: '25 Aug to 8 Sept 2017', year: '2017', venue: 'China', level: 'World Roller Games', achievement: 'Participation' },
          { no: 11, date: '4 to 14 Sept 2018', year: '2018', venue: 'South Korea', level: '18th Asian Roller Skating Championship', achievement: 'Gold' }
        ]
      }
    },
    { name: 'Sanjana', sport: 'Swimming', image: '/assets/int player file 1/sanjana,international Player ,swimming.jpeg' },
    {
      name: 'Satveer',
      sport: 'Skating',
      image: '/assets/int player file 1/satveer ,International player ,skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 2,
        gold: 0,
        silver: 0,
        bronze: 0,
        participation: 2,
        tournaments: [
          { no: 1, date: '4 to 14 July 2019', year: '2019', venue: 'Spain', level: 'World Roller Games', achievement: 'Participation' },
          { no: 2, date: '18-28/10/.2023', year: '2023', venue: 'China', level: '19 TH Asian Roller Skating Championship', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Simranjeet',
      sport: 'Skating',
      image: '/assets/int player file 1/simranjeet,international Player.skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 2,
        gold: 1,
        silver: 0,
        bronze: 0,
        participation: 1,
        tournaments: [
          { no: 1, date: '4 to 14 Sept 2018', year: '2018', venue: 'South Korea', level: '18th Asian Roller Skating Championship', achievement: 'Gold' },
          { no: 2, date: '4 to 14 July 2019', year: '2019', venue: 'Spain', level: 'World Roller Game', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Naveen',
      sport: 'Judo',
      image: '/assets/int player file 2/Naveen ,International Player,Judo.jpg',
      country: 'India',
      details: {
        totalTournaments: 1,
        gold: 0,
        silver: 0,
        bronze: 1,
        participation: 0,
        tournaments: [
          { no: 1, date: '14 to 15 Nov.2009', year: '2009', venue: 'Lebnon', level: '10 th Asian Judo Championship', achievement: 'Bronze' }
        ]
      }
    },
    {
      name: 'Navjeet',
      sport: 'Skating',
      image: '/assets/int player file 1/Navjeet international player Skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 5,
        gold: 0,
        silver: 0,
        bronze: 1,
        participation: 4,
        tournaments: [
          { no: 1, date: '30 to 5 July 2014', year: '2014', venue: 'France', level: 'Inline Hockey World Cup', achievement: 'Participation' },
          { no: 2, date: '20 to 24 Sept. 2014', year: '2014', venue: 'Haning (China)', level: '16th Asian Inline Hockey', achievement: 'Bronze' },
          { no: 3, date: '11 to 25 June 2016', year: '2016', venue: 'Italy', level: 'World Inline Hockey Chmapionship', achievement: 'Participation' },
          { no: 4, date: '12 to 16 Oct 2016', year: '2016', venue: 'China', level: '16th Asian Inline Hockey Championship', achievement: 'Participation' },
          { no: 5, date: '25 Aug to 8 Sept 2017', year: '2017', venue: 'China', level: 'World Roller Games', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Navneet',
      sport: 'Skating',
      image: '/assets/int player file 1/Navneet ,international Player Skating.jpg',
      country: 'India',
      details: {
        totalTournaments: 3,
        gold: 1,
        silver: 0,
        bronze: 0,
        participation: 2,
        tournaments: [
          { no: 1, date: '10 to 17 Nov.2012', year: '2012', venue: 'Brazil', level: '11th World Cup', achievement: 'Participation' },
          { no: 2, date: '28 to 2 Oct. 2012', year: '2012', venue: 'China', level: '15th Asian Championship', achievement: 'Gold' },
          { no: 3, date: '24 Sept to 1 Oct 2016', year: '2016', venue: 'Chile', level: '13th Ladies World Chmapionship', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Neelam',
      sport: 'Yoga',
      image: '/assets/int player file 1/Neelam   ,international Player, Yoga.jpg',
      country: 'India',
      details: {
        totalTournaments: 12,
        gold: 11,
        silver: 10,
        bronze: 7,
        participation: 2,
        tournaments: [
          { no: 1, date: '21 to 23 Sept 2001', year: '2001', venue: 'Arezentina', level: 'World Yoga Championship', achievement: '2 Bronze' },
          { no: 2, date: '18 to 20 Sep. 2009', year: '2009', venue: 'Italy (Rome)', level: '18th World Championship', achievement: '1 Gold' },
          { no: 3, date: '26Sept-27 Sept. 2010', year: '2010', venue: 'Argentina', level: '19th World yoga Championship', achievement: '2 Gold ,1silver' },
          { no: 4, date: '22nd to 23rd Jan., 2011', year: '2011', venue: 'Thailand', level: '1 st Asian Yoga Championship', achievement: '1 Silver' },
          { no: 5, date: '17th Dec., 2011', year: '2011', venue: 'Uruguay', level: 'World Yoga Championship', achievement: 'Participation' },
          { no: 6, date: '31st Aug. to 2nd Sept., 2012', year: '2012-13', venue: 'Hyderabad', level: '2nd Asian Yoga Champ.', achievement: 'Participation' },
          { no: 7, date: '23Nov.-25Nov.2012', year: '2012', venue: 'Moscow,Russia', level: '21st World Yoga Championship', achievement: '1Gold,2 Silver' },
          { no: 8, date: '13th Oct.-14thOct.2013', year: '2013', venue: 'Paris', level: '22ndWorld Yoga Championship', achievement: '2 Gold, 3 Silver, 1 Bronze' },
          { no: 9, date: '14th Nov.-16th Nov.2014', year: '2014-15', venue: 'SOUTH Korea', level: '4th Asian Yoga Champ.', achievement: '1 Gold, 1 Bronze' },
          { no: 10, date: '18thDec.-20thDec.2015', year: '2015-16', venue: 'malaysia', level: '24th world yoga Champ.', achievement: '1Gold, 1 silver,2brounze' },
          { no: 11, date: '19th June to 21June.2015', year: '2015-16', venue: 'thailand', level: '5th Asian Yoga Champ.', achievement: '1 gold, 1 silver ,1 brounze' },
          { no: 12, date: '3rd to 5th Sept.2016', year: '2016-17', venue: 'Vietnam', level: '6th Asian Yoga Champ.', achievement: '1 Gold, 1Silver' }
        ]
      }
    },
    {
      name: 'Neha',
      sport: 'Netball',
      image: '/assets/int player file 1/Neha,I nternational player,Netball.jpg',
      country: 'India',
      details: {
        totalTournaments: 1,
        gold: 0,
        silver: 0,
        bronze: 0,
        participation: 1,
        tournaments: [
          { no: 1, date: '20 to 27 June 2009', year: '2009', venue: 'Malashia', level: '7th Asian Women Championship', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Parveen',
      sport: 'Skating',
      image: '/assets/bheem awardes/Parveen , Bhim Award ,International  Player ,Skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 8,
        gold: 2,
        silver: 2,
        bronze: 0,
        participation: 4,
        award: 'BHIM AWARD',
        tournaments: [
          { no: 1, date: '4 to 9 Sept 2005', year: '2005', venue: 'Geongju', level: '11th Asian Championship', achievement: 'Silver' },
          { no: 2, date: '30 to 8 Oct.2006', year: '2006', venue: 'Chilie', level: '8th World Cup', achievement: 'Participation' },
          { no: 3, date: '9 to 14 Jan.2010', year: '2010', venue: 'Dalian,China', level: '13th Asian Championship', achievement: 'Gold' },
          { no: 4, date: '25 to 2 Jan.2010', year: '2010', venue: 'Spain', level: '10th World Cup', achievement: 'Participation' },
          { no: 5, date: '9 to 14 July 2010', year: '2010', venue: 'Taiwan.Kaohsing', level: '14th Asian Championship', achievement: 'Silver' },
          { no: 6, date: '10 to 17 Nov.2012', year: '2012', venue: 'Brazil', level: '11th World Cup', achievement: 'Participation' },
          { no: 7, date: '28 to 2 Oct. 2012', year: '2012', venue: 'China', level: '15th Asian Championship', achievement: 'Gold' },
          { no: 8, date: '24 Sept to 1 Oct 2016', year: '2016', venue: 'Chile', level: '13th Ladies World Chmapionship', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Parvesh',
      sport: 'Throwball',
      image: '/assets/int player file 2/Parvesh ,International Player, Throwball.jpg',
      country: 'India',
      details: {
        totalTournaments: 2,
        gold: 2,
        silver: 0,
        bronze: 0,
        participation: 0,
        tournaments: [
          { no: 1, date: '-', year: '2009', venue: 'Malashia', level: '3rd Asian Throwball Championship', achievement: 'Gold' },
          { no: 2, date: '29 to 31 March 2010', year: '2010', venue: 'Ezypt', level: '1st World Cup', achievement: 'Gold' }
        ]
      }
    },
    {
      name: 'Poonam Kalra',
      sport: 'Throw ball',
      image: '/assets/poonam kalra.jpeg',
      country: 'India',
      details: {
        totalTournaments: 1,
        gold: 1,
        silver: 0,
        bronze: 0,
        participation: 0,
        tournaments: [
          { no: 1, date: '29 to 31 March 2010', year: '2010', venue: 'Ezypt', level: '1st World Cup', achievement: 'Gold' }
        ]
      }
    },
    {
      name: 'Priyanka Dudi',
      sport: 'Throw Ball',
      image: '/assets/int player file 2/Priyanka Dudi ,International  Player,Throw Ball.jpg',
      country: 'India',
      details: {
        totalTournaments: 2,
        gold: 2,
        silver: 0,
        bronze: 0,
        participation: 0,
        tournaments: [
          { no: 1, date: '-', year: '2009', venue: 'Malashia', level: '3rd Asian Throwball Championship', achievement: 'Gold' },
          { no: 2, date: '29 to 31 March 2010', year: '2010', venue: 'Ezypt', level: '1st World Cup', achievement: 'Gold' }
        ]
      }
    },
    { name: 'Priyanka Kadiyan', sport: 'Throw Ball', image: '/assets/int player file 2/Priyanka Kadiyan, International Player ,Throw ball.jpg' },
    {
      name: 'Ravneet',
      sport: 'Skating',
      image: '/assets/int player file 1/Ravneet,international player, skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 6,
        gold: 0,
        silver: 0,
        bronze: 1,
        participation: 5,
        tournaments: [
          { no: 1, date: '24 to 28 sept.2014', year: '2014', venue: 'China', level: '16th Asian Rollar Hockey Championship', achievement: 'Bronze' },
          { no: 2, date: '30th June -5 July.2014', year: '2014', venue: 'France', level: 'World Inline Hockey Chmapionship', achievement: 'Participation' },
          { no: 3, date: '7-13 June2015', year: '2015', venue: 'Argentina', level: 'World Inline Hockey Chmapionship', achievement: 'Participation' },
          { no: 4, date: '11 to 25 June 2016', year: '2016', venue: 'Italy', level: 'World Inline Hockey Chmapionship', achievement: 'Participation' },
          { no: 5, date: '12 to 16 Oct 2016', year: '2016', venue: 'China', level: '16th Asian Inline Hockey Championship', achievement: 'Participation' },
          { no: 6, date: '25 Aug to 8 Sept 2017', year: '2017', venue: 'China', level: 'World Roller Games', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Rekha',
      sport: 'Judo',
      image: '/assets/int player file 2/REKHA ,International Player,Judo.jpg',
      country: 'India',
      details: {
        totalTournaments: 5,
        gold: 0,
        silver: 1,
        bronze: 1,
        participation: 3,
        tournaments: [
          { no: 1, date: '2 to 8 Aug 2007', year: '2007', venue: 'Yugosalavia(Europe)', level: 'Junior World Judo Championship', achievement: 'Participation' },
          { no: 2, date: '1 to 8 Nov 2007', year: '2007', venue: 'Hyderabad', level: '8th Asian Junior Judo Championship', achievement: 'Participation (4th)' },
          { no: 3, date: '24-28 Jan 2008', year: '2008', venue: 'Mauritius', level: '12th Asian Comman Wealth Junior Cham.', achievement: 'Participation (5th)' },
          { no: 4, date: '13 to 16 Nov 2009', year: '2009', venue: 'Lebnon', level: '10 th Asian Judo Championship', achievement: 'Bronze (3rd)' },
          { no: 5, date: '-', year: '2010-11', venue: 'Uzbekaistan', level: 'Senior Asian Sambo Marshal ArtChamp.', achievement: 'Silver' }
        ]
      }
    },
    {
      name: 'Ritu Nagpal',
      sport: 'Skating',
      image: '/assets/int player file 1/Ritu  international  player  ,skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 10,
        gold: 3,
        silver: 1,
        bronze: 1,
        participation: 5,
        tournaments: [
          { no: 1, date: '10 to 15 August 2003', year: '2003', venue: 'Akita ( Japan)', level: '10th Asian Championship', achievement: 'Bronze' },
          { no: 2, date: '4 to 9 Sept 2005', year: '2005', venue: 'Geongju', level: '11th Asian Championship', achievement: 'Silver' },
          { no: 3, date: '30 to 8 Oct.2006', year: '2006', venue: 'Chilie', level: '8th World Cup', achievement: 'Participation' },
          { no: 4, date: '9 to 14 Jan.2010', year: '2010', venue: 'Dalian,China', level: '13th Asian Championship', achievement: 'Gold' },
          { no: 5, date: '15 to 19 Sept 2010', year: '2010', venue: 'Alcobandas,Madrid', level: '10th World Cup', achievement: 'Participation' },
          { no: 6, date: '10 to 17 Nov.2012', year: '2012', venue: 'Brazil', level: '11th World Cup', achievement: 'Participation' },
          { no: 7, date: '28 to 2 Oct. 2012', year: '2012', venue: 'China', level: '15th Asian Championship', achievement: 'Gold' },
          { no: 8, date: '28 Oct to 4 Nov 2014', year: '2014', venue: 'France', level: '12th World Championship', achievement: 'Participation' },
          { no: 9, date: '24 to 28 sept.2014', year: '2014', venue: 'China', level: '16th Asian Rollar Hockey Championship', achievement: 'Gold' },
          { no: 10, date: '24 Sept to 1 Oct 2016', year: '2016', venue: 'Chile', level: '13th Ladies World Chmapionship', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Ritu',
      sport: 'Sambo',
      image: '/assets/int player file 1/Ritu ,internationl  player, judo.jpg',
      country: 'India',
      details: {
        totalTournaments: 1,
        gold: 0,
        silver: 1,
        bronze: 0,
        participation: 0,
        tournaments: [
          { no: 1, date: '-', year: '2010-11', venue: 'Uzbekaistan', level: 'Senior Asian Sambo Marshal ArtChamp.', achievement: 'Silver' }
        ]
      }
    },
    {
      name: 'Ritu (1108)',
      sport: 'Throwball',
      image: '/assets/int player file 1/Ritu ,internationl  player, judo.jpg',
      country: 'India',
      details: {
        totalTournaments: 1,
        gold: 1,
        silver: 0,
        bronze: 0,
        participation: 0,
        tournaments: [
          { no: 1, date: '09 to 11 Nov 2017', year: '2017', venue: 'Shri Lanka (Kegulu Vidyalaya Indoor Stadium)', level: 'Indian Women Throwball Asian Championship', achievement: 'Gold' }
        ]
      }
    },
    {
      name: 'Sandeep',
      sport: 'Skating',
      image: '/assets/int player file 1/Sandeep ,Internationl Player , Skating.jpg',
      country: 'India',
      details: {
        totalTournaments: 7,
        gold: 2,
        silver: 1,
        bronze: 0,
        participation: 4,
        tournaments: [
          { no: 1, date: '4 to 9 Sept 2005', year: '2005', venue: 'Geongju', level: '11th Asian Championship', achievement: 'Silver' },
          { no: 2, date: '30 to 8 Oct.2006', year: '2006', venue: 'Chilie', level: '8th World Cup', achievement: 'Participation' },
          { no: 3, date: '28 to 2 Dec.2007', year: '2007', venue: 'Kolkata', level: '12th Asian Championship', achievement: 'Gold' },
          { no: 4, date: '9 to 14 Jan.2010', year: '2010', venue: 'Dalian,China', level: '13th Asian Championship', achievement: 'Gold' },
          { no: 5, date: '25 to 2 Jan.2010', year: '2010', venue: 'Alcobandas, Madrid', level: '10th World Cup', achievement: 'Participation' },
          { no: 6, date: '-', year: '2008', venue: 'japan', level: '09th World Cup', achievement: 'Participation' },
          { no: 7, date: '10 to 17 Nov.2012', year: '2012', venue: 'Brazil', level: '11th World Cup', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Sanjeev',
      sport: 'Skating',
      image: '/assets/int player file 1/satveer ,International player ,skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 2,
        gold: 0,
        silver: 0,
        bronze: 1,
        participation: 1,
        tournaments: [
          { no: 1, date: '20 to 24 Sept. 2014', year: '2014', venue: 'Haning (China)', level: '16th Asian Inline Hockey Championship', achievement: 'Bronze' },
          { no: 2, date: '28 Oct to 4 Nov 2014', year: '2014', venue: 'France', level: '12th World Championship', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Santosh',
      sport: 'Netball',
      image: '/assets/int player file 1/Santosh, International Player  Netball.jpg',
      country: 'India',
      details: {
        totalTournaments: 1,
        gold: 0,
        silver: 0,
        bronze: 0,
        participation: 1,
        tournaments: [
          { no: 1, date: '20 to 27 June 2009', year: '2009', venue: 'Malashia', level: '7th Asian Women Championship', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Silvneet',
      sport: 'Skating',
      image: '/assets/int player file 2/Silvneet,International Player,Skating.jpg',
      country: 'India',
      details: {
        totalTournaments: 1,
        gold: 0,
        silver: 0,
        bronze: 0,
        participation: 1,
        tournaments: [
          { no: 1, date: '18-28/10/.2023', year: '2024', venue: 'China', level: '19th Asian Rollar and inline hockey Champ.', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Sonali',
      sport: 'Skating',
      image: '/assets/int player file 1/Sonali ,international  Player,Skating.jpg',
      country: 'India',
      details: {
        totalTournaments: 3,
        gold: 1,
        silver: 0,
        bronze: 0,
        participation: 2,
        tournaments: [
          { no: 1, date: '30 to 8 Oct.2006', year: '2006', venue: 'Chilie', level: '8th World Cup', achievement: 'Participation' },
          { no: 2, date: '28 to 2 Dec.2007', year: '2007', venue: 'Kolkata', level: '12th Asian Championship', achievement: 'Gold' },
          { no: 3, date: '5 to 11 Oct.2008', year: '2008', venue: 'Japan', level: '9th World Cup', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Sonam',
      sport: 'Skating',
      image: '/assets/int player file 1/Sonam, International Player, Skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 4,
        gold: 0,
        silver: 0,
        bronze: 1,
        participation: 3,
        tournaments: [
          { no: 1, date: '30 to 8 Oct.2006', year: '2006', venue: 'Chilie', level: '8th World Cup', achievement: 'Participation' },
          { no: 2, date: '30 to 5 July 2014', year: '2014', venue: 'France', level: 'Inline Hockey World Cup', achievement: 'Participation' },
          { no: 3, date: '20 to 24 Sept. 2014', year: '2014', venue: 'Haning (China)', level: '16th Asian Inline Hockey Championship', achievement: 'Bronze' },
          { no: 4, date: '12 to 16 Oct 2016', year: '2016', venue: 'China', level: '16th Asian Inline Hockey Championship', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Sonia',
      sport: 'Skating',
      image: '/assets/int player file 1/Sonia International Player,Skating.jpg',
      country: 'India',
      details: {
        totalTournaments: 4,
        gold: 2,
        silver: 0,
        bronze: 0,
        participation: 2,
        tournaments: [
          { no: 1, date: '28 Oct to 4 Nov 2014', year: '2014', venue: 'France', level: '12th World Championship', achievement: 'Participation' },
          { no: 2, date: '24 to 28 sept.2014', year: '2014', venue: 'China', level: '16th Asian Rollar Hockey Championship', achievement: 'Gold' },
          { no: 3, date: '25 Aug to 8 Sept 2017', year: '2017', venue: 'China', level: 'World Roller Games', achievement: 'Participation' },
          { no: 4, date: '4 to 14 Sept 2018', year: '2018', venue: 'South Korea', level: '18th Asian Roller Skating Championship', achievement: 'Gold' }
        ]
      }
    },
    {
      name: 'Sumitra',
      sport: 'Skating',
      image: '/assets/int player file 1/Sumitra , international player, skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 7,
        gold: 0,
        silver: 0,
        bronze: 1,
        participation: 6,
        tournaments: [
          { no: 1, date: '23 to 27 Oct 2012', year: '2012', venue: 'China', level: '15th Asian InlineChampionship', achievement: 'Participation' },
          { no: 2, date: '14 to 20 July2013', year: '2013', venue: 'California ( U.S.A.)', level: 'Inline Hockey World Cup', achievement: 'Participation' },
          { no: 3, date: '30 to 5 July 2014', year: '2014', venue: 'France', level: 'Inline Hockey World Cup', achievement: 'Participation' },
          { no: 4, date: '20 to 24 Sept. 2014', year: '2014', venue: 'Haning (China)', level: '16th Asian Inline Hockey Championship', achievement: 'Bronze' },
          { no: 5, date: '12 to 16 Oct 2016', year: '2016', venue: 'China', level: '16th Asian Inline Hockey Championship', achievement: 'Participation' },
          { no: 6, date: '25 Aug to 8 Sept 2017', year: '2017', venue: 'China', level: 'World Roller Games', achievement: 'Participation' },
          { no: 7, date: '25 Aug to 8 Sept 2017', year: '2017', venue: 'China', level: 'World Roller Games', achievement: 'Participation' }
        ]
      }
    },
    {
      name: 'Yashdeep',
      sport: 'Skating',
      image: '/assets/bheem awardes/yashdeep, Bhim award  ,International player, Skating.jpeg',
      country: 'India',
      details: {
        totalTournaments: 12,
        gold: 4,
        silver: 2,
        bronze: 1,
        participation: 5,
        award: 'Bhim Award',
        tournaments: [
          { no: 1, date: '10 to 15 August 2003', year: '2003', venue: 'Akita ( Japan)', level: '10th Asian Championship', achievement: 'Bronze' },
          { no: 2, date: '4 to 9 Sept 2005', year: '2005', venue: 'Geongju', level: '11th Asian Championship', achievement: 'Silver' },
          { no: 3, date: '30 to 8 Oct.2006', year: '2006', venue: 'Chilie', level: '8th World Cup', achievement: 'Participation' },
          { no: 4, date: '28 to 2 Dec.2007', year: '2007', venue: 'Kolkata', level: '12th Asian Championship', achievement: 'Gold' },
          { no: 5, date: '9 to 14 Jan.2010', year: '2010', venue: 'Dalian,China', level: '13th Asian Championship', achievement: 'Gold' },
          { no: 6, date: '15 to 19 Sept 2010', year: '2010', venue: 'Alcobandas,Madrid', level: '10th World Cup', achievement: 'Participation' },
          { no: 7, date: '9 to 14 July 2010', year: '2010', venue: 'Taiwan.Kaohsing', level: '14th Asian Championship', achievement: 'Silver' },
          { no: 8, date: '10 to 17 Nov.2012', year: '2012', venue: 'Brazil', level: '11th World Cup', achievement: 'Participation' },
          { no: 9, date: '28 to 2 Oct. 2012', year: '2012', venue: 'China', level: '15th Asian Championship', achievement: 'Gold' },
          { no: 10, date: '28 Oct to 4 Nov 2014', year: '2014', venue: 'France', level: '12th World Championship', achievement: 'Participation' },
          { no: 11, date: '24 to 28 sept.2014', year: '2014', venue: 'China', level: '16th Asian Rollar Hockey Championship', achievement: 'Gold' },
          { no: 12, date: '24 Sept to 1 Oct 2016', year: '2016', venue: 'Chile', level: '13th Ladies World Chmapionship', achievement: 'Participation' }
        ]
      }
    },
    { name: 'Sonam', sport: 'Throwball', image: '/assets/int player file 2/Sonam ,International  Player ,Throwball.jpg' }
  ];

  constructor() { }

  ngOnInit(): void { }

  openDetails(player: Player): void {
    if (player.details) {
      this.selectedPlayer = player;
    }
  }

  closeDetails(): void {
    this.selectedPlayer = null;
  }
}
